module.exports = __webpack_public_path__ + "img/partners11.0e4e104d.jpg";